import { apiSlice } from "../../apiSlice";
export const aletelegApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDataGraphicAle: builder.mutation({
      query: (parameters) => ({
        url: `/Alertxxx/Aleterlg/getGraphicDataByUser`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "Alertxxx" },
      }),
    }),
    getClientByFilters: builder.mutation({
      query: ({CLIIDXXX}) => ({
        url: `/Alertxxx/Aleterlg/getUtocomplCliente/${CLIIDXXX}`,
        method: "GET",
        headers: { modulecima: "Alertxxx" },
      }),
    }),
    getAlertByFilter: builder.mutation({
      query: ({ALENOMXX}) => ({
        url: `/Alertxxx/Aleterlg/getAutocompltAlertVencimiento/${ALENOMXX}`,
        method: "GET",
        headers: { modulecima: "Alertxxx" },
      }),
    }),
  }),
});

export const { useGetDataGraphicAleMutation, useGetAlertByFilterMutation, useGetClientByFiltersMutation } = aletelegApiSlice;
